<template>
    <modal
        :name="'editarPrecio-' + precio.id"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Editar tipo de abono - {{ precio.descripcion }}</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close(false)">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <FormPrecio :tipo="precio" @terminado="editarPrecio()"/>
            </div>
            <div class="card-footer text-right">
                <Button type="button" name="button" @click.prevent="close(false)">CERRAR</Button>
            </div>
        </div>
    </modal>
</template>

<script>

    import FormPrecio from './sin-recinto/FormPrecio';

    export default {
        props: ['lista_id', 'precio'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            editarPrecio() {
                this.loading = true;

                this.precio.filters = {};
                this.precio.lista_id = this.lista_id;
                this.precio.precio_id = this.precio.id;

                if(this.precio.activo) {
                    this.precio.activo = 1;
                } else {
                    this.precio.activo = 0;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.precios.editar'), this.precio).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
            close(creado) {
                this.$emit('close', 'editarPrecio-' + this.precio.id, creado);
            }
        },
        components: {
            FormPrecio
        }
    }
</script>
